/* eslint-disable react/no-danger */
import React from 'react';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function SportsCards({ data }) {
  const { title, cardsList } = data;

  return (
    <section className="bg-[#F7F7F7] clip-right-top clip-left-bottom pt-16 pb-32 md:pt-32 md:pb-40">
      <div 
      className="container mx-auto px-4 3xl:px-0 w-full lg:w-[80%] 
      relative xl:!max-w-[1170px]">
        <h2
          className="uppercase text-primary font-roboto-condensed-bold 
      lg:text-2xl text-[35px] leading-[45px] mb-4">
          {title}
        </h2>

        {isEmpty(cardsList) || (
          <div className="grid sm:grid-cols-2 lg2:grid-cols-3 gap-8">
            {cardsList.map((card, index) => (
              <div key={index} className='bg-white'>
                <LazyLoadImage src={card.content.image.url} />
                <div className='p-6 xl:p-10'>
                  <h3 
                  className='text-5 2xl:text-[23px] uppercase font-roboto-condensed-bold mb-3'>
                    {card.content.title}
                  </h3>
                  <div 
                  dangerouslySetInnerHTML={{ __html: card.content.text }} 
                  className='[&>p:not(:last-child)]:mb-2 text-[14px] 2xl:text-[16px]'
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
